import { Button, Dropdown, Nav, Navbar, Offcanvas, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT_SUCCESS } from "../redux/actions/action";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainRoutes from "./routes";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { getAppSettings, getPreviewStatusByToken } from "../api/api";
import {
  getPreviewTokenFromPath,
  getPreviewTokenFromSearch,
  getStoredPreviewToken,
  storePreviewToken,
  getPreviewBlockedMessage,
  setPreviewBlockedMessage,
  clearPreviewBlockedMessage,
  withPreviewToken,
  isPreviewPath,
} from "../helpers/preview";
import PopupModel from "./popupmodel";
import DniPromptModal from "../components/DniPromptModal";
import SupportWhatsAppButton from "../components/SupportWhatsAppButton";
import sol  from "../assets/image/soleado 1.svg";
import cherow from "../assets/image/flecha-hacia-abajo-para-navegar 1.svg";
import { ConfigProvider } from "antd";
import "./navbar.css";
import "./navbar.mobile.css";
import searchIcon from "../assets/image/lupa 1.svg";
import menuIcon from "../assets/image/menu-2 1.svg";
import downloadIcon from "../assets/logos app/descargar (2) 1.svg";
import { loadMetaPixel, trackMetaPixel } from "../helpers/metaPixel";
import { loginStateFrom } from "./loginReturn";

const APP_STORE_LINK = "https://apps.apple.com/us/app/zoco-tickets/id6758010461";
const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=com.men7ar31.zocotickets";

const resolveStoreLink = () => {
  if (typeof navigator === "undefined") return APP_STORE_LINK;
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return PLAY_STORE_LINK;
  if (/iphone|ipad|ipod/i.test(ua)) return APP_STORE_LINK;
  return APP_STORE_LINK;
};

const AppRouter2 = () => {
  const [activelink, setActiveLink] = useState("");
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [appSettings, setAppSettings] = useState({});
  const [show, setShow] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [mobileSearchQuery, setMobileSearchQuery] = useState("");
  const mobileSearchRef = useRef(null);
  const [desktopSearchQuery, setDesktopSearchQuery] = useState("");
  const [desktopSearchOpen, setDesktopSearchOpen] = useState(false);
  const desktopSearchRef = useRef(null);
  const desktopSearchWrapRef = useRef(null);
  const desktopToggleRef = useRef(null);
  const hasTrackedFirstRouteRef = useRef(false);
  const [previewCheckError, setPreviewCheckError] = useState("");
  const [previewChecking, setPreviewChecking] = useState(false);
  const lastPreviewTokenRef = useRef("");
  const [previewBlockedMessage, setPreviewBlockedMessageState] = useState(() => getPreviewBlockedMessage());
  const lastPreviewTokenResetRef = useRef("");
  const resolvePreviewBlockMessage = (err) => {
    const status = err?.response?.status;
    const message = String(err?.response?.data?.message || "");
    if (!status) return "";
    if ([403, 410, 429].includes(status)) {
      return message || "Vista previa no disponible";
    }
    if (status === 404) {
      const lower = message.toLowerCase();
      if (lower.includes("link") || lower.includes("no encontrado") || lower.includes("no disponible")) {
        return message || "Vista previa no disponible";
      }
      return "";
    }
    return "";
  };
  const previewTokenFromSearch = useMemo(
    () => getPreviewTokenFromSearch(location.search),
    [location.search]
  );
  const previewTokenFromPath = useMemo(
    () => getPreviewTokenFromPath(location.pathname),
    [location.pathname]
  );
  const [storedPreviewToken, setStoredPreviewToken] = useState(() => getStoredPreviewToken());
  const previewToken = previewTokenFromSearch || previewTokenFromPath || storedPreviewToken;
  const isPreview = Boolean(previewToken);
  const isPreviewRoute = useMemo(
    () => isPreviewPath(location.pathname),
    [location.pathname]
  );

  const fetchAppSettings = async () => {
    try {
      const response = await getAppSettings();
      if (response.status === 200) {
        setAppSettings(response.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { setActiveLink(location.pathname); }, [location.pathname]);

  useEffect(() => {
    AOS.init({ disable: () => window.innerWidth < 900 });
    fetchAppSettings();
  }, []);

  useEffect(() => {
    if (isPreview) return;
    if (!loadMetaPixel()) return;
    if (!hasTrackedFirstRouteRef.current) {
      hasTrackedFirstRouteRef.current = true;
      return;
    }
    trackMetaPixel("PageView");
  }, [isPreview, location.pathname, location.search]);

  // Temporary: redirect any home route to events while Home is under design
  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/event", { replace: true });
    }
  }, [location.pathname]);

  const isOrganizerRoute = location.pathname.startsWith("/organizer");
  // /entrar canjea el código del portal de Zoco y decide él adónde sigue.
  const isEntrarRoute = location.pathname.startsWith("/entrar");
  const isAuthRoute = location.pathname.startsWith("/login") || location.pathname.startsWith("/register") || isEntrarRoute;

  useEffect(() => {
    // En /entrar no: si la pestaña ya tenía una sesión de organizador —de otro negocio—, este
    // salto la sacaría antes del canje y la dejaría parada en el negocio viejo.
    if (isPreview || isEntrarRoute) return;
    const role = String(auth?.user?.role || "").toUpperCase();
    if (auth?.isAuthenticated && (role === "ORGANIZER" || role === "SELLER") && !location.pathname.startsWith("/organizer")) {
      navigate("/organizer", { replace: true });
    }
  }, [auth?.isAuthenticated, auth?.user?.role, location.pathname, navigate, isPreview, isEntrarRoute]);

  useEffect(() => {
    const token = previewTokenFromSearch || previewTokenFromPath;
    if (token && token !== storedPreviewToken) {
      storePreviewToken(token);
      setStoredPreviewToken(token);
    }
  }, [previewTokenFromSearch, previewTokenFromPath, storedPreviewToken]);

  useEffect(() => {
    if (!isPreview) {
      clearPreviewBlockedMessage();
      setPreviewBlockedMessageState("");
      setPreviewCheckError("");
      lastPreviewTokenResetRef.current = "";
      return;
    }
    if (previewToken && lastPreviewTokenResetRef.current !== previewToken) {
      clearPreviewBlockedMessage();
      setPreviewBlockedMessageState("");
      setPreviewCheckError("");
      lastPreviewTokenResetRef.current = previewToken;
    }
    setPreviewBlockedMessageState(getPreviewBlockedMessage());
  }, [isPreview, previewToken]);

  useEffect(() => {
    const handler = (event) => {
      const msg = event?.detail || "";
      setPreviewBlockedMessageState(msg);
      if (msg) setPreviewCheckError(msg);
    };
    window.addEventListener("preview-blocked", handler);
    return () => {
      window.removeEventListener("preview-blocked", handler);
    };
  }, []);

  useEffect(() => {
    if (!isPreview || !previewToken) {
      setPreviewCheckError("");
      setPreviewChecking(false);
      lastPreviewTokenRef.current = "";
      return;
    }
    const isNewToken = lastPreviewTokenRef.current !== previewToken;
    if (isNewToken) setPreviewChecking(true);
    let active = true;
    getPreviewStatusByToken(previewToken)
      .then(() => {
        if (!active) return;
        setPreviewCheckError("");
      })
      .catch((err) => {
        if (!active) return;
        const message = resolvePreviewBlockMessage(err);
        setPreviewCheckError(message || "");
        if (message) {
          setPreviewBlockedMessage(message);
        }
      })
      .finally(() => {
        if (!active) return;
        if (isNewToken) setPreviewChecking(false);
      });
    lastPreviewTokenRef.current = previewToken;
    return () => {
      active = false;
    };
  }, [isPreview, previewToken, location.pathname, location.search]);

  useEffect(() => {
    if (!isPreview || isPreviewRoute) return;
    const nextSearch = withPreviewToken(location.search, previewToken);
    if (nextSearch === location.search) return;
    navigate({ pathname: location.pathname, search: nextSearch }, { replace: true, state: location.state });
  }, [isPreview, isPreviewRoute, location.pathname, location.search, previewToken, navigate, location.state]);

  useEffect(() => {
    if (!isPreview) return;
    const blocked = [
      "/cart",
      "/payment",
      "/myevents",
      "/account",
      "/organizer",
      "/login",
      "/register",
    ];
    if (blocked.some((prefix) => location.pathname.startsWith(prefix))) {
      navigate({ pathname: "/event", search: withPreviewToken("", previewToken) }, { replace: true, state: location.state });
    }
  }, [isPreview, location.pathname, navigate, previewToken, location.state]);
  const handleMenuClick = (path) => { setShow(false); navigate(path); };
  const handleMobileSearchSubmit = (e) => {
    e && e.preventDefault && e.preventDefault();
    const q = (mobileSearchQuery || "").trim();
    if (q) {
      if (loadMetaPixel()) {
        trackMetaPixel("Search", { search_string: q });
      }
      navigate(`/event`, { state: { search: q } });
      setMobileSearchOpen(false);
    }
  };
  const handleDesktopSearchSubmit = (e) => {
    e && e.preventDefault && e.preventDefault();
    const q = (desktopSearchQuery || "").trim();
    if (q) {
      if (loadMetaPixel()) {
        trackMetaPixel("Search", { search_string: q });
      }
      navigate(`/event`, { state: { search: q } });
    }
  };
  const handleDownloadClick = () => {
    const url = resolveStoreLink();
    try {
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (_) {
      window.location.href = url;
    }
  };

  // Close inline search on route change
  useEffect(() => {
    setMobileSearchOpen(false);
    setMobileSearchQuery("");
    setDesktopSearchOpen(false);
    setDesktopSearchQuery("");
  }, [location.pathname]);

  // Close desktop search on outside click or ESC
  useEffect(() => {
    if (!desktopSearchOpen) return;
    const onDocClick = (e) => {
      const wrap = desktopSearchWrapRef.current;
      const toggle = desktopToggleRef.current;
      if (wrap && wrap.contains(e.target)) return;
      if (toggle && toggle.contains(e.target)) return;
      setDesktopSearchOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setDesktopSearchOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [desktopSearchOpen]);

  const previewBlockMessage = previewBlockedMessage || previewCheckError;
  const isPreviewBlocked = Boolean(isPreview && previewBlockMessage);

  return (
    <ConfigProvider theme={{ token: { colorBgBase: "#ffffff", colorText: "#2D3035", colorPrimary: "#B1C20E", borderRadius: 12, fontFamily: "Montserrat, Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif" } }}>
      <div className="app-shell theme-minimal">
        {isPreview && !isOrganizerRoute && !isAuthRoute && (
          <div className="preview-global-banner" role="status">
            Vista previa (solo lectura)
          </div>
        )}
        {/* Mobile navbar (no afecta escritorio) */}
        {!isOrganizerRoute && !isAuthRoute && (
          <div className="mobile-navbar">
            {!mobileSearchOpen ? (
              <button className="brand" onClick={() => navigate("/event")}>
                <img src={appSettings.logo} alt="logo" width={98} height={23} decoding="async" />
              </button>
            ) : (
              <form className="search-inline" onSubmit={handleMobileSearchSubmit}>
                <input
                  ref={mobileSearchRef}
                  type="search"
                  className="search-input"
                  placeholder="Buscar evento"
                  value={mobileSearchQuery}
                  onChange={(e) => setMobileSearchQuery(e.target.value)}
                  aria-label="Buscar evento"
                  autoComplete="off"
                />
              </form>
            )}
            <div className="actions">
              <button
                className="icon-btn"
                aria-label="Buscar"
                onClick={() => {
                  setMobileSearchOpen((v) => !v);
                  setTimeout(() => mobileSearchRef.current && mobileSearchRef.current.focus(), 0);
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2D3035" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </button>
              <button className="icon-btn" aria-label="Descargar app" onClick={handleDownloadClick}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2D3035" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </button>
              <button className="icon-btn" aria-label="Menú" onClick={() => setShow(true)}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2D3035" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </button>
            </div>
          </div>
        )}

        

        {!isOrganizerRoute && !isAuthRoute && (
          <Navbar key="md" expand="md" style={{ height: 105,  maxWidth:1250, minWidth:1250, paddingLeft:35, paddingRight:35 }} className="bg-body-tertiary pading150 desktop-navbar">
            <Container fluid style={{ padding: 0 }}>
              <Navbar.Brand as="a" onClick={() => navigate("/event")} style={{ cursor: "pointer" }}>
                <img src={appSettings.logo} alt="logo" width={98} height={23} decoding="async" />
              </Navbar.Brand>
              <div style={{ display: "flex" }}>
                <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={() => setShow(true)} />
              </div>
              <Navbar.Offcanvas id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel" placement="end" show={show} onHide={() => setShow(false)}>
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel">Menú</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="d-flex justify-content-between align-items-center">
                  <Nav className="main-nav me-auto align-items-center">
                    {/*<Nav.Link as="a" onClick={() => handleMenuClick("/event")} active={activelink === "/"} style={{ cursor: "pointer" }}>Inicio</Nav.Link>
                    <span className="nav-sep d-none d-md-inline">|</span>*/}
                    <Nav.Link as="a" onClick={() => handleMenuClick("/event")} active={activelink.startsWith("/event")} style={{ cursor: "pointer" }}>Eventos</Nav.Link>
                    <span className="nav-sep d-none d-md-inline">|</span>
                    <Nav.Link as="a" onClick={() => handleMenuClick("/reservas")} active={activelink.startsWith("/reservas") || activelink.startsWith("/canchas") || activelink.startsWith("/beauty")} style={{ cursor: "pointer" }}>Reservas</Nav.Link>
                    <span className="nav-sep d-none d-md-inline">|</span>
                    <Nav.Link href="https://zocopagos.com/" target="_blank" rel="noreferrer" style={{ cursor: "pointer" }}>
                      Pagos
                    </Nav.Link>
                    <span className="nav-sep d-none d-md-inline">|</span>
                    <Nav.Link href="https://organizador.zocotickets.com/" target="_blank" rel="noreferrer" style={{ cursor: "pointer" }}>
                      Para organizadores
                    </Nav.Link>
                  </Nav>

                  <Nav className="align-items-center right-actions">
                    {desktopSearchOpen && (
                      <form ref={desktopSearchWrapRef} className="nav-search d-none d-md-flex" onSubmit={handleDesktopSearchSubmit} role="search">
                        <input
                          ref={desktopSearchRef}
                          type="search"
                          className="nav-search-input"
                          placeholder="Buscar eventos"
                          value={desktopSearchQuery}
                          onChange={(e) => setDesktopSearchQuery(e.target.value)}
                          aria-label="Buscar eventos"
                        />
                        <button type="submit" className="nav-search-commit" aria-label="Buscar">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2D3035" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" />
                          </svg>
                        </button>
                      </form>
                    )}

                    {!desktopSearchOpen && (
                      <button
                        ref={desktopToggleRef}
                        type="button"
                        className="nav-search-toggle d-none d-md-inline-flex"
                        aria-label="Buscar"
                        onClick={() => {
                          setDesktopSearchOpen(true);
                          setTimeout(() => desktopSearchRef.current && desktopSearchRef.current.focus(), 0);
                        }}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2D3035" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="11" cy="11" r="8" />
                          <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                      </button>
                    )}

                    {isPreview ? (
                      <span className="nav-preview-pill">Solo lectura</span>
                    ) : auth.isAuthenticated ? (
                        <Dropdown className="myaccountdropdown">
                          <Dropdown.Toggle className="nav-outline-btn" variant="light" id="dropdown-basic">Mi perfil</Dropdown.Toggle>
                          <Dropdown.Menu className="myaccountdropdownmenu">
                            {["ORGANIZER", "SELLER"].includes(String(auth?.user?.role || "").toUpperCase()) && (
                              <Dropdown.Item onClick={() => handleMenuClick("/organizer")}>Panel de Organizador</Dropdown.Item>
                            )}
                             <Dropdown.Item onClick={() => handleMenuClick("/account/profile")}>Datos personales</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleMenuClick("/myevents")}>Mis eventos</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleMenuClick("/reservas/historial")}>Mis reservas</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleMenuClick("/account/password")}>Cambiar contraseña</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setShow(false); dispatch({ type: LOGOUT_SUCCESS }); }}>Cerrar sesión</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : (
                        <Button className="fs-6 fw-semibold nav-outline-btn" variant="light" onClick={() => { setShow(false); navigate("/login", { state: loginStateFrom(location) }); }}>
                          Iniciar sesión
                        </Button>
                      )}
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
            <PopupModel />
          </Navbar>
        )}
        {/* Offcanvas reutilizable para mobile; mismo contenido que escritorio */}
        {!isOrganizerRoute && !isAuthRoute && (
          <Offcanvas placement="end" show={show} onHide={() => setShow(false)} className="d-md-none">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">Menú</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="mobile-menu">
                {isPreview ? (
                  <>
                    <div className="mobile-menu-note">Vista previa (solo lectura)</div>
                    <button type="button" className={`mobile-menu-item ${activelink.startsWith('/event') ? 'active' : ''}`} onClick={() => handleMenuClick('/event')}>Eventos</button>
                    <button type="button" className={`mobile-menu-item ${activelink.startsWith('/reservas') || activelink.startsWith('/canchas') || activelink.startsWith('/beauty') ? 'active' : ''}`} onClick={() => handleMenuClick('/reservas')}>Reservas</button>
                    <a className="mobile-menu-item" href="https://zocopagos.com/" target="_blank" rel="noreferrer">
                      Pagos
                    </a>
                    <a className="mobile-menu-item" href="https://organizador.zocotickets.com/" target="_blank" rel="noreferrer">
                      Para organizadores
                    </a>
                  </>
                ) : auth.isAuthenticated ? (
                  <>
                    <button type="button" className={`mobile-menu-item mobile-menu-toggle ${activelink.startsWith('/account') ? 'active' : ''}`} onClick={() => setShowProfile((v) => !v)}>
                      <span>Perfil</span>
                      <img className={`chev-icon ${showProfile ? 'open' : ''}`} src={cherow} alt="abrir" />
                    </button>
                    {showProfile && (
                      <div className="mobile-submenu">
                        <button type="button" className="mobile-subitem" onClick={() => handleMenuClick('/account/profile')}>Datos personales</button>
                        <button type="button" className="mobile-subitem" onClick={() => handleMenuClick('/account/password')}>Cambiar la contraseña</button>
                      </div>
                    )}
                    <button type="button" className={`mobile-menu-item ${activelink.startsWith('/myevents') ? 'active' : ''}`} onClick={() => handleMenuClick('/myevents')}>Mis eventos</button>
                    <button type="button" className={`mobile-menu-item ${activelink.startsWith('/reservas/historial') || activelink.startsWith('/canchas/historial') ? 'active' : ''}`} onClick={() => handleMenuClick('/reservas/historial')}>Mis reservas</button>
                    <button type="button" className={`mobile-menu-item ${(activelink.startsWith('/reservas') && !activelink.startsWith('/reservas/historial')) || (activelink.startsWith('/canchas') && !activelink.startsWith('/canchas/historial')) || activelink.startsWith('/beauty') ? 'active' : ''}`} onClick={() => handleMenuClick('/reservas')}>Reservas</button>
                    <a className="mobile-menu-item" href="https://zocopagos.com/" target="_blank" rel="noreferrer">
                      Pagos
                    </a>
                    <a className="mobile-menu-item" href="https://organizador.zocotickets.com/" target="_blank" rel="noreferrer">
                      Para organizadores
                    </a>
                    <div className="mobile-menu-sep" />
                    <button type="button" className="mobile-menu-item danger" onClick={() => { setShow(false); dispatch({ type: LOGOUT_SUCCESS }); }}>Cerrar sesión</button>
                  </>
                ) : (
                  <>
                    <button type="button" className="mobile-menu-item" onClick={() => { setShow(false); navigate("/login", { state: loginStateFrom(location) }); }}>Iniciar sesión</button>
                    <button type="button" className={`mobile-menu-item ${activelink.startsWith('/reservas') || activelink.startsWith('/canchas') || activelink.startsWith('/beauty') ? 'active' : ''}`} onClick={() => handleMenuClick('/reservas')}>Reservas</button>
                    <a className="mobile-menu-item" href="https://zocopagos.com/" target="_blank" rel="noreferrer">
                      Pagos
                    </a>
                    <a className="mobile-menu-item" href="https://organizador.zocotickets.com/" target="_blank" rel="noreferrer">
                      Para organizadores
                    </a>
                  </>
                )}
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        )}
        <main className="app-content">
          <MainRoutes />
        </main>
        <DniPromptModal currentPathname={location.pathname} />
        {!isOrganizerRoute && !isAuthRoute && !isPreview && location.pathname.startsWith("/event") && <SupportWhatsAppButton phone={appSettings.phone} />}
        {!isOrganizerRoute && !isAuthRoute && <Footer />}
      </div>
    </ConfigProvider>
  );
};

export default AppRouter2;
